<template src="./listManagementVue.template.html"></template>
<script>
  import foliomodal from "../../../components/reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";

  export default {
    name: "ListManagementComponent",
    props: [],
    components: {
      foliomodal
    },
    data() {
      return {
        listManagementList: [],
        showropertyDropdown: false,
        propertyId: null,
        propertyList: [],
        systemList: [],
        customList: [],
        IsClient: 1,
        statusList: [],
        StatusId: null,
        ListId: null,
        customListName: "",
        disableNewItem: true,
        listTypeID: 0,
        ListTypeName: "Amenities",
        hideActionInProperty1: true,
        hideActionInProperty2: true,
        client: true,
        propertyactive: false,
        showNewRow: false,
        showLedgerType: false,
        showLedgerTypeDropDown: false,
        LedgerAccountTypeList: [],
        LedgerAccountTypeID: null,
        cssColor: "Amenities",
        showImageBtn: true,
        showTextBgColor: false,
        showFileUpload: false,
        DropDownList: [],
        sysStatusId: 1,
        cusStatusId: 1,
        showLess: true,
        showMore: false,
        showInputInClient: true,
        hideInputInProperty: false,
        multipleUnitstatus: [],
        className1: "col-md-7",
        className2: "col-md-5",

        UnitClassColor: [
          {
            value: "unitypeColorPicker_1",
            unitcolor1: null,
            background: "#bfcaff",
            borderColor: "#1000d4",
            color: "#1000d4"
          },
          {
            value: "unitypeColorPicker_2",
            unitcolor1: null,
            background: "#f9dada",
            borderColor: "#fe0002",
            color: "#fe0002"
          },
          {
            value: "unitypeColorPicker_3",
            unitcolor1: null,
            background: "#bfefc1",
            borderColor: "#47af4b",
            color: "#47af4b"
          },
          {
            value: "unitypeColorPicker_4",
            unitcolor1: null,
            background: "#ffe7c4",
            borderColor: "#ff9803",
            color: "#ff9803"
          },
          {
            value: "unitypeColorPicker_5",
            unitcolor1: null,
            background: "#ffe8f0",
            borderColor: "#eb1462",
            color: "#eb1462"
          },
          {
            value: "unitypeColorPicker_6",
            unitcolor1: null,
            background: "#c7e4fb",
            borderColor: "#1292f5",
            color: "#1292f5"
          },
          {
            value: "unitypeColorPicker_7",
            unitcolor1: null,
            background: "#d7e1e6",
            borderColor: "#5f7c8c",
            color: "#5f7c8c"
          },
          {
            value: "unitypeColorPicker_8",
            unitcolor1: null,
            background: "#fffdde",
            borderColor: "#a9a032",
            color: "#a9a032"
          },
          {
            value: "unitypeColorPicker_9",
            unitcolor1: null,
            background: "#f9d9d0",
            borderColor: "#7a5449",
            color: "#7a5449"
          },
          {
            value: "unitypeColorPicker_10",
            unitcolor1: null,
            background: "#f9effb",
            borderColor: "#9c1ab2",
            color: "#9c1ab2"
          },
          {
            value: "unitypeColorPicker_11",
            unitcolor1: null,
            background: "#f7ffe5",
            borderColor: "#7c9a3d",
            color: "#7c9a3d"
          },
          {
            value: "unitypeColorPicker_12",
            unitcolor1: null,
            background: "#fff0f2",
            borderColor: "#e35667",
            color: "#e35667"
          },
          {
            value: "unitypeColorPicker_13",
            unitcolor1: null,
            background: "#ff8f90",
            borderColor: "#fe0002",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_14",
            unitcolor1: null,
            background: "#818fec",
            borderColor: "#344ad6",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_15",
            unitcolor1: null,
            background: "#79bb7c",
            borderColor: "#38843c",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_16",
            unitcolor1: null,
            background: "#e8b640",
            borderColor: "#987625",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_17",
            unitcolor1: null,
            background: "#9a7bcc",
            borderColor: "#502990",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_18",
            unitcolor1: null,
            background: "#c58776",
            borderColor: "#7a5449",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_19",
            unitcolor1: null,
            background: "#f38654",
            borderColor: "#e04e0a",
            color: "#ffffff"
          },
          {
            value: "unitypeColorPicker_20",
            unitcolor1: null,
            background: "#e05a8b",
            borderColor: "#bb1e57",
            color: "#ffffff"
          }
        ],
        ColorCode: null,
        customEntityList:[],
        selectedCustomEntityItem:[],
        showFields: false,
        customEntityFieldTypes:[],
        fieldDetails:{
          fieldName: '',
          fieldType: { fieldTypeId: null, fieldTypeName: '' },
        },
        customFieldsList:[{}],
        LOV_Fields: [],
        selectedOption: 0,
        savedLovFields: [],
        isMultiSelect: false,
        lov_error: '',
        isModalVisible: false,
        modalParams:[],
        // selectedCustomFieldToDelete: null,
        customFieldStatusId: null,
        selectedStatusId: 1,
        getAllCustomFields: null,
        showSelectedLovList: false,
        selectedLovList: [],
        selectedList:[]
      };
    },

    methods: {
      // systemColorPicker: function(colorvalue, list) {
      //   let vm = this;
      //   console.log(colorvalue);
      //   console.log("colorvalue",colorvalue);
      //   var index = vm.systemList.indexOf(list);

      //   vm.systemList[index].ColorCode = colorvalue;
      //   console.log("vm.systemList[index].ColorCode",vm.systemList[index].ColorCode);

      //   console.log("vm.ColorCode",vm.ColorCode);

      //   console.log();
      // },

      ShowcustomList(list) {
        let vm = this;
        // console.log("list=====>", list)
        if (list.ListId != null && vm.$store.state.userEntitlementList.fncListItemUpdate.isAssigned == 1) {
          // console.log("list.listid",list.ListId);
          return true
        }
        else if (list.ListId == null && vm.$store.state.userEntitlementList.fncListItemSave.isAssigned == 1) {
          return true
        }
      },

      customColorPicker: function (colorvalue, list) {
        let vm = this;
        console.log(colorvalue);
        console.log("colorvalue", colorvalue);

        var index = vm.customList.indexOf(list);
       if(index > -1){
          vm.customList[index].ColorCode = colorvalue;
          vm.StatusId = list.StatusId;
          vm.ListId = list.ListId;
          vm.customListName = list.ListName;
          vm.LedgerAccountTypeID = list.ledgerAccountTypeID;
        }
          vm.ColorCode = colorvalue;
         
        
      },
      switchView() {
        let scope = this;
        if (scope.listType === "list") scope.listType = "card";
        else scope.listType = "list";
      },

      getlistManagementList: function () {
        let scope = this;
        console.log("In get list Management List");
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetlistManagementList",
          params: {
            ModuleAction: "GetlistManagementList"
          },
          callback: function (err, response) {
            if (response) {
              console.log("getlistManagementList", response);
              scope.listManagementList = response.recordsets[0];
              // console.log(
              //   "array+++++++++-------------------" +
              //     JSON.stringify(scope.listManagementList)
              // );
              for (var i = 0; i < scope.listManagementList.length; i++) {
                var str = scope.listManagementList[i].LISTNAME;
                var strs = scope.listManagementList[i].STATUS;
                if (str == null) {
                  console.log("can not split");
                } else {
                  var str_array = str.split(",");
                  var str_array1 = strs.split(",");
                  scope.listManagementList[i].LISTNAME = str_array;
                  scope.listManagementList[i].STATUS = str_array1;
                  scope.listManagementList[i].arrayList = [];
                  for (var x in scope.listManagementList[i].LISTNAME) {
                    scope.listManagementList[i].arrayList.push({
                      statusid: scope.listManagementList[i].STATUS[x],
                      listname: scope.listManagementList[i].LISTNAME[x]
                    });
                  }
                  for (var y in scope.listManagementList[i].arrayList) {
                    if (scope.listManagementList[i].arrayList[y].statusid == 1) {
                      scope.listManagementList[i].arrayList[y].csscolor = "black";
                    }
                    if (scope.listManagementList[i].arrayList[y].statusid == 0) {
                      scope.listManagementList[i].arrayList[y].csscolor = "gray";
                    }
                  }
                  // console.log(
                  //   "arrayList +++++++++++++++++++++++++" +
                  //   JSON.stringify(scope.listManagementList[i].arrayList)
                  // );
                }
                if (scope.listManagementList[i].TOTALCOUNT > 8) {
                  scope.listManagementList[i].totalcount =
                    scope.listManagementList[i].TOTALCOUNT - 8 + " More...";
                } else {
                  scope.listManagementList[i].TOTALCOUNT = "";
                }
                scope.listManagementList[i].showMore = false;
                scope.listManagementList[i].showLess = true;
                // var str1 = scope.listManagementList[i].CustomListName;
                // var strs1 = scope.listManagementList[i].CustomStatusId;
                // if (str1 == null) {
                //   console.log("can not split");
                // } else {
                //   var str_array = str1.split(",");
                //   var str_array1 = strs.split(",");
                //   scope.listManagementList[i].CustomListName = str_array;
                //   scope.listManagementList[i].CustomStatusId = str_array1;
                //   console.log(
                //     "array+++++++++-------------------" +
                //       JSON.stringify(scope.listManagementList[i])
                //   );
                // }
              }
            } else {
              console.log(err);
            }
          }
        });
      },

      getSystemList: function (listTypeID) {
        let scope = this;
        console.log("In get list Management List");
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetSystemList",
          params: {
            ModuleAction: "GetSystemList",
            listTypeID: listTypeID,
            propertyId: scope.propertyId,
            IsClient: scope.IsClient,
            LedgerAccountTypeId: scope.LedgerAccountTypeID,
            sysStatusId: scope.sysStatusId,
            cusStatusId: scope.cusStatusId
          },
          callback: function (err, response) {
            if (response) {
              // console.log("")
              console.log("getSystemList==>", response);
              scope.systemList = response.recordsets[1];
              console.log("uniclases of color code==>", response.recordsets[1]);
              scope.statusList = response.recordsets[0];
              scope.customList = response.recordsets[2];
              // console.log("scope.customList======>",scope.customList);
              // for (var i in scope.systemList) {
              //   scope.$set(scope.systemList[i], "ColorCode", "");
              // }
              // for (var i in scope.customList) {
              //   scope.$set(scope.customList[i], "UnitClassColorName", "");
              // }

              // console.log("scope.customList", JSON.stringify(scope.customList));

            } else {
              console.log(err);
            }
          }
        });
      },

      getPropertyMetaData: function () {
        // let scope = this;
        // scope.$store.dispatch("dataRequestHandler", {
        //   key: "GetPropertyMetaData",
        //   params: {
        //     ModuleAction: "GetPropertyMetaData",
        //     PropertyId: scope.propertyId
        //   },
        //   callback: function(err, response) {
        //     if (response) {
        //       scope.propertyList = response.recordsets[1];
        //       scope.statusList = response.recordsets[3];
        //       scope.DropDownList.splice(0, scope.DropDownList.length, {
        //         PropertyId: null,
        //         PropertyName: "client"
        //       });
        //       for (var i = 0; i < scope.propertyList.length; i++) {
        //         scope.DropDownList.push(scope.propertyList[i]);
        //       }
        //     } else {
        //       console.log(err);
        //     }
        //   }
        // });
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);

            }
          }
        });

      },

      showPropertyList() {
        let scope = this;
        scope.showLedgerType = false;
        scope.showLedgerTypeDropDown = false;
        if (scope.ListTypeName == "Ledger Accounts") {
          scope.showLedgerType = true;
        }
        scope.showropertyDropdown = true;
        scope.IsClient = 0;
        scope.getSystemList(scope.listTypeID);
        scope.disableNewItem = false;
        scope.hideActionInProperty1 = false;
        scope.hideActionInProperty2 = false;
        scope.client = false;
        scope.propertyactive = true;
        scope.showInputInClient = false;
        scope.hideInputInProperty = true;
        scope.LedgerAccountTypeID = null;
        scope.getSystemList(scope.listTypeID);
      },

      hidePropertyList() {
        let scope = this;
        scope.showLedgerType = false;
        scope.showLedgerTypeDropDown = false;
        scope.hideActionInProperty1 = true;
        scope.hideActionInProperty2 = true;
        if (scope.ListTypeName == "Ledger Accounts") {
          scope.showLedgerType = true;
          scope.showLedgerTypeDropDown = true;
          scope.hideActionInProperty1 = false;
        }
        scope.showropertyDropdown = false;
        scope.propertyId = null;
        scope.IsClient = 1;
        scope.getSystemList(scope.listTypeID);
        scope.disableNewItem = true;
        scope.client = true;
        scope.showInputInClient = true;
        scope.hideInputInProperty = false;
        scope.propertyactive = false;
        scope.getSystemList(scope.listTypeID);
      },

      viewListManagementDetail(listManagement) {
        let scope = this;
        scope.cssColor = listManagement.ListTypeName;
        scope.showInputInClient = true;
        scope.hideInputInProperty = false;
        scope.showLedgerType = false;
        scope.showLedgerTypeDropDown = false;
        scope.hideActionInProperty1 = true;
        scope.hideActionInProperty2 = true;
        scope.showImageBtn = false;
        scope.showTextBgColor = false;
        if (listManagement.ListTypeName == "Amenities") {
          scope.showImageBtn = true;
          scope.className1 = "col-md-7";
          scope.className2 = "col-md-5";
          scope.sysStatusId = 1;
          scope.cusStatusId = 1;
          scope.propertyactive =  false;
          scope.client = true;
          scope.selectedCustomEntityItem =  null; // Setting the Custom Fields > selectedCustomEntityItem to null when a different entity is selected.
          scope.closeFields();
          vm.showSelectedLovList = false;
        }
        if (listManagement.ListTypeName == "Ledger Accounts") {
          scope.showLedgerType = true;
          scope.hideActionInProperty1 = false;
          scope.showLedgerTypeDropDown = true;
          scope.className1 = "col-md-7";
          scope.className2 = "col-md-5";
          scope.sysStatusId = 1;
          scope.cusStatusId = 1;
          scope.propertyactive =  false;
          scope.client = true;
          scope.showLedgerList();
          scope.selectedCustomEntityItem =  null; // Setting the Custom Fields > selectedCustomEntityItem to null when a different entity is selected.
          scope.closeFields();
          vm.showSelectedLovList = false;
        }
        if (listManagement.ListTypeName == "Unit Classes") {
          scope.hideActionInProperty1 = false;
          scope.showTextBgColor = true;
          scope.className1 = "col-md-7";
          scope.className2 = "col-md-5";
          scope.sysStatusId = 1;
          scope.cusStatusId = 1;
          scope.propertyactive =  false;
          scope.client = true;
          scope.selectedCustomEntityItem =  null; // Setting the Custom Fields > selectedCustomEntityItem to null when a different entity is selected.
          scope.closeFields();
          vm.showSelectedLovList = false;
        }
        scope.LedgerAccountTypeID = null;
        scope.ListTypeName = listManagement.ListTypeName;
        scope.showropertyDropdown = false;
        scope.IsClient = 1;
        scope.disableNewItem = true;
        scope.showNewRow = false;
        scope.listTypeID = listManagement.ListTypeId;
        scope.getSystemList(listManagement.ListTypeId);
        scope.getPropertyMetaData();
        scope.propertyId = null;
      },

      AddNewCustomItem: function () {
        let scope = this;
         scope.customListName = "",
          scope.StatusId = "",
          scope.showNewRow = true,
          scope.ColorCode = null

      },

      getStausId(list) {
        let scope = this;
        scope.StatusId = list.StatusId;
        scope.ListId = list.ListId;
        scope.customListName = list.ListName;
        scope.LedgerAccountTypeID = list.ledgerAccountTypeID;
      },
      // getStausId(list) {
      //   console.log("list",list);
      //   let scope = this;
      //   scope.multipleUnitstatus.push(list)

      // },
      getCustomListName(list) {
        let scope = this;
        scope.customListName = list.ListName;
        console.log(scope.customListName);
      },

      getCustomlistByPropertyId() {
        let scope = this;
        if (scope.propertyId == null) {
          scope.showLedgerType = false;
          scope.showLedgerTypeDropDown = false;
          scope.hideActionInProperty1 = true;
          scope.hideActionInProperty2 = true;
          if (scope.ListTypeName == "Ledger Accounts") {
            scope.showLedgerType = true;
            scope.showLedgerTypeDropDown = true;
            scope.hideActionInProperty1 = false;
          }
          scope.showropertyDropdown = false;
          scope.propertyId = null;
          scope.IsClient = 1;
          scope.getSystemList(scope.listTypeID);
          scope.disableNewItem = true;
          scope.client = true;
          scope.propertyactive = false;
        } else {
          scope.showLedgerType = false;
          scope.showLedgerTypeDropDown = false;
          if (scope.ListTypeName == "Ledger Accounts") {
            scope.showLedgerType = true;
          }
          scope.showropertyDropdown = true;
          scope.IsClient = 0;
          scope.getSystemList(scope.listTypeID);
          scope.disableNewItem = false;
          scope.hideActionInProperty1 = false;
          scope.hideActionInProperty2 = false;
          scope.client = false;
          scope.propertyactive = true;
          scope.LedgerAccountTypeID = null;
        }
        scope.getSystemList(scope.listTypeID);
      },

      saveCustomList(list, StatusId) {
        let scope = this;
        scope.showNewRow = false;
        if(list && StatusId == -2){
              scope.ListId = list.ListId,
              scope.customListName = list.ListName,
              scope.ColorCode = list.ColorCode,
              scope.StatusId = StatusId,
              scope.LedgerAccountTypeID = list.ledgerAccountTypeID
        }
        console.log(scope.customListName);
        console.log(scope.LedgerAccountTypeID);
        console.log(scope.StatusId);
        if (scope.customListName === "" || scope.customListName === null) {
          scope.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "please enter custom List name"
          });
        }

        else if (scope.ListTypeName == "Ledger Accounts") {
          scope.$store.dispatch("dataRequestHandler", {
            key: "SaveLedgerAccounts",
            params: {
              ModuleAction: "SaveLedgerAccounts",
              ledgerAccountID: scope.ListId,
              PropertyId: scope.propertyId,
              ledgerAccountNumber: scope.customListName,
              ledgerAccountName: scope.customListName,
              ledgerAccountDescription: null,
              ledgerAccountTypeID: scope.LedgerAccountTypeID,
              StatusId: scope.StatusId,
              // MultipleStatus: scope.customList,         
              listTypeID: scope.listTypeID
            },
            callback: function (err, response) {
              if (response) {
                scope.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Ledger Accounts CustomList successfully saved"
                });
                scope.getlistManagementList();
              } else {
                console.log(err);
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "Ledger Accounts CustomList Error!",
                  message: err.sqlMessage ? err.sqlMessage : err
                });
              }
            }
          });
        }
        else if (scope.customListName === "" || scope.customListName === null) {
          scope.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "please enter custom List name"
          });
        }
        else {
          scope.$store.dispatch("dataRequestHandler", {
            key: "SaveCustomList",
            params: {
              ModuleAction: "SaveCustomList",
              ListId: scope.ListId,
              ListName: scope.customListName,
              ListDesc: null,
              listTypeID: scope.listTypeID,
              colorCode: scope.ColorCode,
              StatusId: scope.StatusId,
              PropertyId: scope.propertyId
              // MultipleStatus: scope.customList
            },
            callback: function (err, response) {
              if (response) {
                scope.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "CustomList successfully saved"
                });
                scope.getlistManagementList();
              } else {
                console.log(err);
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "CustomList save Error!",
                  message: err.sqlMessage ? err.sqlMessage : err
                });
              }
            }
          });
        }
        scope.LedgerAccountTypeID = null;
        scope.getSystemList(scope.listTypeID);
        scope.getlistManagementList();
      },

      showLedgerList: function () {
        let scope = this;
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetLedgerAccountTypes",
          params: {
            ModuleAction: "ledgerList"
          },
          callback: function (err, response) {
            if (response) {
              scope.LedgerAccountTypeList = response.recordsets[0];
            } else {
              console.log(err);
            }
          }
        });
      },

      getLedgerAccountTypeID: function () {
        let scope = this;
        scope.getSystemList(scope.listTypeID);
      },

      getLedgerAccountID: function (list) {
        let scope = this;
        console.log(
          "acc type id ==== +++++++++++++ ===== +++++++++ " +
          scope.LedgerAccountTypeID
        );
        scope.StatusId = list.StatusId;
        scope.ListId = list.ListId;
        scope.customListName = list.ListName;
        scope.LedgerAccountTypeID = list.ledgerAccountTypeID;
      },

      classObject: function (listtypename) {
        return this.cssColor === listtypename;
      },

      showImageFile() {
        this.showFileUpload = !this.showFileUpload;
      },

      processLogo(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          this.ProfileImage = null;
          return;
        } else {
          this.createImage(files[0]);
        }
      },

      createImage(file) {
        let reader = new FileReader();
        let vm = this;
        reader.onload = e => {
          vm.image = e.target.result;
          this.ProfileImage = vm.image;
        };
        console.log("image=====================++++++++++++" + e);
        reader.readAsDataURL(file);
      },

      showList(index) {
        let scope = this;
        scope.listManagementList[index].showLess = !scope.listManagementList[
          index
        ].showLess;
        scope.listManagementList[index].showMore = !scope.listManagementList[
          index
        ].showMore;
        if (
          scope.listManagementList[index].showMore == false &&
          scope.listManagementList[index].showLess == true
        ) {
          scope.listManagementList[index].totalcount =
            scope.listManagementList[index].TOTALCOUNT - 8 + " More...";
        } else {
          scope.listManagementList[index].totalcount = "Show Less";
        }
      },

      changeCustomListName(list) {
        let scope = this;
        console.log(
          "listname ==================== >>>>>>>>>>>>>>>>>>>>>>",
          list.ListName
        );
        scope.StatusId = list.StatusId;
        scope.ListId = list.ListId;
        scope.customListName = list.ListName;
        scope.LedgerAccountTypeID = list.ledgerAccountTypeID;
        scope.getSystemList(scope.listTypeID);
      },

      getSystemListByStatusId() {
        let scope = this;
        scope.getSystemList(scope.listTypeID);
      },

      exportToExcel: function () { },
      getCustomEntityList() {
        let scope = this;
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetCustomEntityList",
          params: {
            ModuleAction: "GetCustomEntityList"
          },
          callback: function (err, response) {
            if (response) {
              scope.customEntityList = response
              console.log('GetCustomEntityList response', response);
            } else {
              console.log("GetCustomEntityList error",err);
            }
          }
        });
      },
      selectedCustomEntity(entity,listManagement){
        let scope = this;
        scope.viewListManagementDetail(listManagement)
        scope.selectedCustomEntityItem = entity;
        scope.getCustomFields();
        scope.showSelectedLovList = false;
        scope.selectedStatusId = 1;
      },
      getCustomEntityFieldTypes(){
        let scope = this;
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetCustomEntityFieldTypes",
          params: {
            ModuleAction: "GetCustomEntityFieldTypes"
          },
          callback: function (err, response) {
            if (response) {
              scope.customEntityFieldTypes = response
              console.log('GetCustomEntityFieldTypes response', response);
            } else {
              console.log("GetCustomEntityFieldTypes error",err);
            }
          }
        });
      },
      closeFields(){
        let scope = this;
        scope.showFields = false;
        scope.fieldDetails = {
          fieldName: '',
          fieldType: { fieldTypeId: null, fieldTypeName: '' },
        }
        scope.LOV_Fields = [];
        scope.savedLovFields = [];
        scope.selectedOption = 0;
        scope.isMultiSelect = false;
      },
      addCustomFields(fieldDetails) {
        let scope = this;
        scope.saveListOfValues();
        let fieldExists = scope.getAllCustomFields.some(field => field.CustomFieldName.toUpperCase() === fieldDetails.fieldName.toUpperCase());
        if (fieldExists) {
          scope.$store.dispatch("toastr", {
            type: "warning",
            message: "The custom field name already exists. Please use a different name.",
            header: "Warning",
          });
          return;
        }
        if(fieldDetails.fieldName === "" || fieldDetails.fieldType.fieldTypeId === null || fieldDetails.fieldType.fieldTypeName === "" || (fieldDetails.fieldType.fieldTypeId === 4 && (!scope.savedLovFields || scope.savedLovFields.length <= 0 || scope.savedLovFields.some(field => field.value === "")))){
          scope.$store.dispatch("toastr", {
            type: "warning",
            message: "Please Fill all Mandatory Fields",
            header: "Warning",
          });
        }else{
          const joinConfig = {
            ListOfValues: scope.savedLovFields ? scope.savedLovFields : null,
            isMultiSelect: scope.isMultiSelect ? scope.isMultiSelect : false
          };
          scope.$store.dispatch("dataRequestHandler", {
            key: "AddCustomFields",
            params: {
              CustomEntityID: scope.selectedCustomEntityItem.CustomEntityID,
              FieldTypeID: fieldDetails.fieldType.fieldTypeId,
              CustomFieldName: fieldDetails.fieldName,
              Config: fieldDetails.fieldType.fieldTypeId == 4 ? JSON.stringify(joinConfig) : null,
              FieldTypeName: fieldDetails.fieldType.fieldTypeName
            },
            callback: function (err, response) {
              if (response) {
                console.log('AddCustomFields response', response);
                scope.getCustomFields();
                scope.fieldDetails = {
                  fieldName: '',
                  fieldType: { fieldTypeId: null, fieldTypeName: '' },
                }
                scope.LOV_Fields = [];
                scope.savedLovFields = [];
                scope.selectedOption = 0;
                scope.isMultiSelect = false;
                scope.$store.dispatch("toastr", {
                  type: "success",
                  message: "Custom Fields added successfully",
                  header: "Success",
                });
                scope.showFields = false;
              } else {
                console.log("AddCustomFields error",err);
                scope.$store.dispatch("toastr", {
                  type: "error",
                  message: "Error while adding Custom Fields",
                  header: "Error",
                });
              }
            }
          });
        }
      },
      getCustomFields() {
        let scope = this;
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetCustomFields",
          params: {
            // ClientID: 5,
            CustomEntityID: scope.selectedCustomEntityItem.CustomEntityID,
            StatusID: 1,
          },
          callback: function (err, response) {
            if (response) {
              scope.customFieldsList = response.recordsets[0];
              console.log('GetCustomFields response', response);
            } else {
              console.log("GetCustomFields error",err);
            }
          }
        });
      },
      getAllCustomFieldsFnc() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetAllCustomFields",
          params: {},
          callback: function (err, response) {
            if (response) {
              vm.getAllCustomFields = response;
              console.log('GetAllCustomFields response', response);
            } else {
              console.log("GetAllCustomFields error",err);
            }
          }
        });
      },
      addLovItem() {
        this.LOV_Fields.push({ label: '', value: '' });
      },
      deleteLovItem(index) {
        this.LOV_Fields.splice(index, 1);
      },
      saveListOfValues() {
        if (this.selectedOption !== null) {
          this.LOV_Fields.forEach((field, index) => {
            field.selected = index === this.selectedOption;
          });

          this.savedLovFields = this.LOV_Fields.map(field => ({
            value: field.value,
            isDefault: field.selected,
            statusId: 1
          }));
          console.log('Saved LOV_Fields:', this.savedLovFields);
          this.lov_error = '';
        } else {
          this.lov_error = 'Please select an option.';
        }
      },
      // deleteCustomFieldsAndInstances(){
      //   let scope = this;
      //   scope.$store.dispatch("dataRequestHandler", {
      //     key: "DeleteCustomFieldsAndInstances",
      //     params: {
      //       CustomEntityID: scope.selectedCustomFieldToDelete.CustomEntityID,
      //       FieldID: scope.selectedCustomFieldToDelete.FieldID,
      //       CustomFieldName: scope.selectedCustomFieldToDelete.CustomFieldName,
      //     },
      //     callback: function (err, response) {
      //       if (response) {
      //         console.log('DeleteCustomFieldsAndInstances response', response);
      //         scope.getCustomFields();
      //         scope.closeModal();
      //         scope.$store.dispatch("toastr", {
      //         type: "success",
      //         header: "Success!",
      //         message: "Custom Field deleted successfully"
      //       });
      //       } else {
      //         console.log("DeleteCustomFieldsAndInstances error",err);
      //         scope.$store.dispatch("toastr", {
      //         type: "error",
      //         header: "Error!",
      //         message: "Error while deleting Custom Field"
      //       });
      //       }
      //     }
      //   });
      // },
      openModal(list){
        // this.selectedCustomFieldToDelete = list
        this.isModalVisible = true;
        this.modalParams = {
            popupTitle: "Custom Field",
            popupMessage: `This custom field is currently in use. To delete it, remove its associated value.`,
            displayYesNoButtons: false,
            cancelbuttonCallback: this.closeModal,
            noCloseButton: false,
            footer: false
        };
      },
      closeModal(){
        this.isModalVisible = false;
      },
      updateCustomFieldsAndInstances(list){
        let scope = this;
        console.log('UpdateCustomFieldsAndInstances list', list);
        scope.$store.dispatch("dataRequestHandler", {
          key: "UpdateCustomFieldsAndInstances",
          params: {
            CustomEntityID: list.CustomEntityID,
            FieldID: list.FieldID,
            CustomFieldName: list.CustomFieldName,
            StatusID: list.StatusId
          },
          callback: function (err, response) {
            if (response) {
              console.log('UpdateCustomFieldsAndInstances response', response);
              if(response && response.recordsets && response.recordsets[0] && response.recordsets[0][0] && response.recordsets[0][0].Message){
                scope.openModal(list);
              }else{
                scope.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: `Custom Field status updated successfully`
                });
              }
              // scope.getCustomFields();
              scope.getCustomFieldsListByStatusId(scope.selectedStatusId);
            } else {
              console.log("UpdateCustomFieldsAndInstances error",err);
            }
          }
        });
      },
      getCustomFieldsListByStatusId(statusId){
        let vm = this;
        vm.selectedStatusId = statusId;
        vm.showSelectedLovList = false;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetCustomFields",
          params: {
            CustomEntityID: vm.selectedCustomEntityItem.CustomEntityID,
            StatusID: statusId,
          },
          callback: function (err, response) {
            if (response) {
              vm.customFieldsList = response.recordsets[0];
              console.log('getCustomFieldsListByStatusId response', response);
            } else {
              console.log("getCustomFieldsListByStatusId error",err);
            }
          }
        });
      },
      addFieldsFnc(){
        let vm = this;
        vm.showFields = true;
        vm.showSelectedLovList = false;
        vm.getAllCustomFieldsFnc();
      },
      getSelectedLovList(list){
        let vm = this;
        if(list.FieldTypeID == 4 && list.StatusId == 1){
          vm.showSelectedLovList = true;
          vm.$store.dispatch("dataRequestHandler", {
          key: "GetCustomFields",
          params: {
            CustomEntityID: vm.selectedCustomEntityItem.CustomEntityID,
            StatusID: 1,
          },
          callback: function (err, response) {
            if (response) {
              const lovResponse = response.recordsets[0].filter(field => field.FieldID === list.FieldID);
              vm.selectedList = lovResponse[0];
              vm.selectedLovList = JSON.parse(lovResponse[0].Config).ListOfValues;
            } else {
              console.log("GetCustomFields error",err);
            }
          }
        });
        }else{
          vm.showSelectedLovList = false;
        }
      },
      addNewLov() {
        let vm = this;
        vm.selectedLovList.unshift({ value: '', isDefault: false, statusId: 1, newLOV: true});
      },
      deleteNewLovItem(index) {
        this.selectedLovList.splice(index, 1);
      },
      saveNewLovList() {
        let vm = this;    
        const filteredLovList = vm.selectedLovList.filter(lov => lov.statusId !== -2);
        const formattedList = filteredLovList.map((field, index) => ({
          value: field.value,
          isDefault: index === this.selectedOption,
          statusId: field.statusId
        }));

        const joinConfig = {
          ListOfValues: formattedList,
          isMultiSelect: JSON.parse(vm.selectedList.Config).isMultiSelect
        };

        if (formattedList.some(field => field.value === "")) {
          this.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please fill all mandatory values"
          });
          return;
        }
      
        vm.$store.dispatch("dataRequestHandler", {
          key: "UpdateCustomFields",
          params: {
            CustomEntityID: vm.selectedCustomEntityItem.CustomEntityID,
            Config: JSON.stringify(joinConfig),
            FieldID: vm.selectedList.FieldID,
            FieldTypeID: vm.selectedList.FieldTypeID,
          },
          callback: function (err, response) {
            if (response) {
              vm.getCustomFields();
              vm.getSelectedLovList(vm.selectedList);
              console.log('UpdateCustomFields response', response);
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: `List of Values Updated Successfully`
              });
              // vm.showSelectedLovList = false;
            } else {
              console.log("UpdateCustomFields error",err);
            }
          }
        });
      }
    },

    computed: {
      fncIsListItemNew() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncListItemNew")) {

          return vm.$store.state.userEntitlementList.hasOwnProperty("fncListItemNew") ? vm.$store.state.userEntitlementList.fncListItemNew : null;

        }
      },
      // fncIsListItemUpdate(){
      //   let vm = this;
      //   if (vm.$store.state.userEntitlementList.hasOwnProperty("fncListItemUpdate")) {

      //     return vm.$store.state.userEntitlementList.hasOwnProperty("fncListItemUpdate") ? vm.$store.state.userEntitlementList.fncListItemNew : null;

      //   }
      // },
      // fncIsListItemNew() {
      //   let vm = this;
      //   if (vm.ListId === null) {
      //     console.log("fncIsListItemNew vm.ListId", vm.ListId);
      //     return vm.$store.state.userEntitlementList.hasOwnProperty(
      //       "fncListItemNew"
      //     )
      //       ? vm.$store.state.userEntitlementList.fncListItemNew
      //       : null;
      //   } else if (vm.ListId > 0) {
      //     console.log("fncListItemUpdate vm.ListId", vm.ListId);
      //     return vm.$store.state.userEntitlementList.hasOwnProperty(
      //       "fncListItemUpdate"
      //     )
      //       ? vm.$store.state.userEntitlementList.fncListItemUpdate
      //       : null;
      //   }
      // }

      fncIsListItemSave() {
        let vm = this;
        if (vm.ListId === null) {
          console.log("fncListItemSave vm.ListId", vm.ListId);
          return vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncListItemSave"
          )
            ? vm.$store.state.userEntitlementList.fncListItemSave
            : null;
        } else if (vm.ListId > 0) {
          console.log("fncListItemUpdate vm.ListId", vm.ListId);
          return vm.$store.state.userEntitlementList.hasOwnProperty(
            "fncListItemUpdate"
          )
            ? vm.$store.state.userEntitlementList.fncListItemUpdate
            : null;
        }
      }
    },

    mounted() {
      this.getlistManagementList();
      this.getSystemList(0);
      this.getPropertyMetaData();

      // Custom Entity
      this.getCustomEntityList();
      this.getCustomEntityFieldTypes();
      this.getAllCustomFieldsFnc();
    }
  };
</script>
<style scoped>
.CustomEntityNameClass{
  padding: 9px 15px 9px 15px !important;
}
.CustomEntityNameClass label{
  margin-bottom: 0;
}
.selected-entity {
    color: #4D70E0;
    font-weight: bold;
    border: 2px dashed #95A6AF !important;
    /* text-align: center; */
    background-color: #FFFFFF;
    border-radius:10px;
}
.CustomEntityNameClass {
  border: 2px dashed transparent;
  margin-bottom: 5px;
}
.CustomEntityNameClass:hover {
  border: 2px dashed #95A6AF;
  background-color: #FFFFFF;
  border-radius:10px;
  font-weight: bold;
  cursor: pointer;
}
.dTBody.CustomFieldsList{
  max-height: calc(50vh - 135px);
} 
.warningToolTip{
  width: 20vw !important;
}
.modal-backdrop .modal-header{
  padding: 1rem;
}
.modal_class{
  top: auto !important;
}
.lm_CustomFields{
  font-size: 14px;
}
</style>   